import { render, staticRenderFns } from "./GlobalMiniVideo.vue?vue&type=template&id=b09991bc&scoped=true"
import script from "./GlobalMiniVideo.vue?vue&type=script&lang=js"
export * from "./GlobalMiniVideo.vue?vue&type=script&lang=js"
import style0 from "./GlobalMiniVideo.vue?vue&type=style&index=0&id=b09991bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09991bc",
  null
  
)

export default component.exports